"use server";

import { cookies, getRequestContext } from "@rangojs/router";
import { encrypt, getSessionSecret } from "../session";
import { FlashMessage } from "../location-states";

export const loginAction = async (formData: FormData) => {
  const ctx = getRequestContext()!;
  const email = (formData.get("email") as string)?.trim();
  const password = formData.get("password") as string;

  if (!email || !password) {
    return {
      user: null as { email: string } | null,
      error: "Email and password are required",
    };
  }

  if (email !== "admin@admin.com" || password !== "admin") {
    return {
      user: null as { email: string } | null,
      error: "Invalid email or password",
    };
  }

  // Set encrypted session cookie
  const encrypted = await encrypt(JSON.stringify({ email }), getSessionSecret(ctx.env));
  cookies().set("session", encrypted, {
    httpOnly: true,
    sameSite: "lax",
    path: "/",
    maxAge: 86400,
  });
  ctx.setLocationState([
    FlashMessage({
      text: "Welcome back! You're now signed in.",
      type: "success",
    }),
  ]);

  // throw redirect(ctx.reverse("home"), {
  //   state: [
  //     FlashMessage({
  //       text: "Welcome back! You're now signed in.",
  //       type: "success",
  //     }),
  //   ],
  // });
};
